import React, { useState } from 'react';
import { submitContactMessage } from '../services/dataService';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await submitContactMessage(formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-layout">
              <div className="hero-left">
                <h1 className="hero-title">
                  <span className="hero-title-line1">Let's</span>
                  <span className="hero-title-line2">Contact Us</span>
                </h1>
              </div>
              <div className="hero-center">
                <p className="hero-subtitle">Get in touch with our gardening experts</p>
              </div>
              <div className="hero-right">
                <p className="hero-description">
                  Have questions about our products or need gardening advice? 
                  We're here to help you create the perfect garden.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2 className="form-title">Send us a Message</h2>
              <p className="form-subtitle">
                Fill out the form below and we'll get back to you as soon as possible.
              </p>

              {submitStatus === 'success' && (
                <div className="alert alert-success">
                  <h4>Message Sent Successfully!</h4>
                  <p>Thank you for contacting us. We'll get back to you within 24 hours.</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="alert alert-error">
                  <h4>Error Sending Message</h4>
                  <p>There was an error sending your message. Please try again or contact us directly.</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject" className="form-label">Subject *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="product-inquiry">Product Inquiry</option>
                      <option value="gardening-advice">Gardening Advice</option>
                      <option value="order-support">Order Support</option>
                      <option value="partnership">Partnership</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="form-textarea"
                    rows="6"
                    placeholder="Tell us how we can help you..."
                    required
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="btn btn-primary btn-large"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="loading"></span>
                      Sending...
                    </>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <h2 className="info-title">Get in Touch</h2>
              <p className="info-subtitle">
                We're here to help with all your gardening needs.
              </p>

              <div className="contact-info">
                <div className="contact-item">
                  <div className="contact-icon">
                    <span>📞</span>
                  </div>
                  <div className="contact-details">
                    <h3>Phone</h3>
                    <p>+91 8890060211</p>
                    <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <span>✉️</span>
                  </div>
                  <div className="contact-details">
                    <h3>Email</h3>
                    <p>DhrtiMaaOrganics@gmail.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <span>📍</span>
                  </div>
                  <div className="contact-details">
                    <h3>Address</h3>
                    <p>Balaji Vihar-29, VKIA</p>
                    <p>Jaipur-302013</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="faq-content">
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3 className="faq-question">What types of fertilizers do you offer?</h3>
                <p className="faq-answer">
                  We offer a wide range of organic and natural fertilizers including compost, 
                  liquid fertilizers, granular fertilizers, and specialty plant foods.
                </p>
              </div>
              <div className="faq-item">
                <h3 className="faq-question">Do you provide gardening advice?</h3>
                <p className="faq-answer">
                  Yes! Our team of gardening experts is always ready to help with advice 
                  on plant care, soil preparation, and garden planning.
                </p>
              </div>
              <div className="faq-item">
                <h3 className="faq-question">Do you offer bulk discounts?</h3>
                <p className="faq-answer">
                  Yes, we offer special pricing for bulk orders. Contact us for 
                  custom quotes on large quantity purchases.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;